<button mdbBtn type="button" color="secondary" (click)="onClick()" mdbWavesEffect [disabled]="processing"
    class="btn-sm api_button2" size="sm">
    <div *ngIf="processing" class="spinner-border spinner-border-sm" style="margin-right: 5px;" role="status">
    </div>
    <!-- <div *ngIf="processing" class="spinner-grow spinner-grow-sm" style="margin-right: 5px;" role="status">
    </div> -->
    <ng-content></ng-content>
</button>